import { KeycloakService } from "keycloak-angular";
import { environment } from 'src/environments/environment';

export function initializeKeycloak(keycloak: KeycloakService) {
    return() =>
      keycloak.init({
        config: {
          url: environment.keycloak.url,
          realm: environment.keycloak.realm,
          clientId: environment.keycloak.clientId,
        },
        initOptions: {
          onLoad: 'check-sso',
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
          flow: 'standard',
          checkLoginIframe: false
        }
      }).then(() => {
        setInterval(async () => {
          try {
            const refreshed = await keycloak.updateToken(120);
            if(refreshed) {
              //console.log('Token refreshed');             
            } else {
              console.warn('Token not refreshed');
            }
          } catch (err) {
            console.error('Failed to refresh token');
          }
        }, 540000);
      });
}
